
import { defineComponent, ref, onMounted, reactive, computed, toRefs } from 'vue'
import { useStore } from 'vuex'
import { Vendor } from "@/classes/vendor";
import axios from '../../../axios-vendor'

export default defineComponent({
    setup () {
        const name = ref('Vendor Profile')
        const vendorId = ref<any>(window.localStorage.getItem('PAYMENT_PORTAL_ID'))
        const show = ref<boolean>(false)
        const loading = ref<boolean>(false)
        const store = useStore()
        const form = reactive({
            id: vendorId,
            vendor_name: '',
            contact_no: '',
            address: '',
            email: '',
            vendor_id: '',
            current_password: '',
            password: '',
            password_confirmation: '',
        })

        const auth_vendor = computed(() => store.getters["AuthVendor/auth_vendor"]);

        const getVendor = async () => {
            const url = 'auth-vendor';
            const response = await axios.get(url);
            const u: Vendor = response.data.data;
            await store.dispatch('AuthVendor/setVendor', new Vendor(
                u.id,
                u.email,
                u.vendor_name,
                u.vendor_id,
                u.address,
                u.contact_no,
                u.org_id,
                u.first_time_logged_in
            ));

            const { id, email, vendor_name, address, contact_no, vendor_id } = toRefs(form);
            id.value = auth_vendor.value.id;
            email.value = auth_vendor.value.email;
            vendor_name.value = auth_vendor.value.vendor_name;
            address.value = auth_vendor.value.address;
            contact_no.value = auth_vendor.value.contact_no;
            vendor_id.value = auth_vendor.value.vendor_id;
        };

        const handleFinish = () => {
            form.id = vendorId.value
            loading.value = true
            store.dispatch('AuthVendor/updateProfile', form)
            .finally(() => {
                loading.value = false
            })
        }

        onMounted(() => {
            
            if(auth_vendor.value.id){
                setForm()
            } else {
                getVendor()
            }
        })

        const setForm = () => {
            const { id, email, vendor_name, address, contact_no, vendor_id } = toRefs(form);
            id.value = auth_vendor.value.id;
            email.value = auth_vendor.value.email;
            vendor_name.value = auth_vendor.value.vendor_name;
            address.value = auth_vendor.value.address;
            contact_no.value = auth_vendor.value.contact_no;
            vendor_id.value = auth_vendor.value.vendor_id;
        }
        
        return {
            name,
            form,
            handleFinish,
            show,
            loading,
        }
    },
})
